import { formatCurrency } from "@builder/utils/format";
import { ActiveCart, CustomerNote, PaymentMethod, Product, ProductType } from "@common/build/activeEntityType";
import { CashLedgerData, EOSData, ReceiptData } from "@common/build/printLayoutTypes";
import { BuilderOption } from "@common/components/BuilderInterface";
import { v4 } from "uuid";

export const searchOptions: BuilderOption[] = [
    { value: "1", label: "Hoodie blanket", type: "product" },
    { value: "2", label: "Hoodie Allen", type: "customer" },
    { value: "3", label: "Hoodie for men", type: "product" },
    { value: "4", label: "Hoodie Pillow", type: "product" },
    { value: "5", label: "#498984 - Hoodie Marsh", type: "order" }
];

export const radioOptions: Record<string, string> = {
    tshirts: "T-shirts",
    hoodies: "Hoodies",
    socks: "Socks",
    hats: "Hats",
    gloves: "Gloves"
};

export const products: Product[] = [
    {
        _id: "5f8f9e7d0b0b5b001e2f2f3c",
        externalId: "1",
        taxTable: "",
        name: "Graphic T-Shirt",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/graphictshirt.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f3a",

        externalId: "2",
        taxTable: "",
        name: "Snapback Ball Cap",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/snapbackballcap.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f3b",
        externalId: "3",
        taxTable: "",
        name: "Colorful Dress Shirt",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/colorfuldressshirt.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f3d",
        externalId: "4",
        taxTable: "",
        name: "Accent Pillow",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/accentpillow.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f3e",
        externalId: "5",
        taxTable: "",
        name: "Face Mask",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/facemask.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f3f",
        externalId: "6",
        taxTable: "",
        name: "Camping Mug",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/campingmug.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f40",
        externalId: "7",
        taxTable: "",
        name: "Coffee Cup",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/coffeecup.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f41",
        externalId: "8",
        taxTable: "",
        name: "Graphic T-Shirt",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/graphictshirt.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f42",
        externalId: "9",
        taxTable: "",
        name: "Snapback Ball Cap",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/snapbackballcap.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f43",
        externalId: "10",
        taxTable: "",
        name: "Colorful Dress Shirt",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/colorfuldressshirt.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f44",
        externalId: "11",
        taxTable: "",
        name: "Accent Pillow",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/accentpillow.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f45",
        externalId: "12",
        taxTable: "",
        name: "Face Mask",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/facemask.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f46",
        externalId: "13",
        taxTable: "",
        name: "Camping Mug",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/campingmug.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f47",
        externalId: "14",
        taxTable: "",
        name: "Coffee Cup",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/coffeecup.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f48",
        externalId: "15",
        taxTable: "",
        name: "Graphic T-Shirt",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/graphictshirt.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f49",
        externalId: "16",
        taxTable: "",
        name: "Snapback Ball Cap",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/snapbackballcap.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f4a",
        externalId: "17",
        taxTable: "",
        name: "Colorful Dress Shirt",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/colorfuldressshirt.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f4b",
        externalId: "18",
        taxTable: "",
        name: "Accent Pillow",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/accentpillow.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f4c",
        externalId: "19",
        taxTable: "",
        name: "Face Mask",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/facemask.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f4d",
        externalId: "20",
        taxTable: "",
        name: "Camping Mug",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/campingmug.png"]
    },
    {
        _id: "5f8f9e7d0b0b5b001e2f2f4e",
        externalId: "",
        taxTable: "",
        name: "Coffee Cup",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean sollicitudin, libero semper faucibus vehicula, ligula sapien porttitor risus, eu lacinia mi felis id turpis. Nunc fringilla euismod odio. Aenean tincidunt sed ante eget feugiat.",
        shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        categories: { name: "Clothing", externalId: "" },
        attributes: [],
        productType: ProductType.SIMPLE,
        variants: [],
        images: ["/coffeecup.png"]
    }
];

export const recieptSampleData: ReceiptData = {
    currency: "CAD",
    orderNotes: ["ORDER NOTES"],
    customSales: [],
    payments: [
        {
            method: "Card",
            date: new Date(),
            amount: 4000
        },
        {
            method: "Cash",
            date: new Date(),
            amount: 0,
            change: 0
        }
    ],
    cartFees: [
        {
            amount: 2000,
            percentAmount: "10%"
        },
        {
            amount: 65000,
            percentAmount: "30%"
        },
        {
            amount: 10000,
            percentAmount: "5%"
        }
    ],
    products: [
        {
            name: "Sample Product title",
            sku: "1238431",
            price: 1000,
            totalPrice: 1000,
            description: "Sample Product Description",
            productNote: "Sample Product note",
            quantity: 1,
            discount: {
                amount: 1000,
                percentAmount: "75%"
            },
            cartDiscount: {
                amount: 0,
                percentAmount: "2%"
            },
            fee: {
                itemFee: {
                    amount: 5000,
                    percentAmount: "20%"
                },
                cartFee: {
                    amount: 2000,
                    percentAmount: "10%"
                }
            },
            modifiers: [
                {
                    name: "Sample modifier",
                    amount: 500
                }
            ],
            taxes: [
                {
                    name: "HST",
                    amount: 1000,
                    percentAmount: "15%"
                },
                {
                    name: "GST",
                    amount: 1000,
                    percentAmount: "10%"
                }
            ],
            productTotal: 2000
        },
        {
            name: "Sample Product title 2",
            sku: "1238431",
            price: 1000,
            totalPrice: 1000,
            description: "Sample Product Description 2",
            productNote: "Sample Product note 2",
            quantity: 1,
            discount: {
                amount: 1000,
                percentAmount: "5%"
            },
            cartDiscount: {
                amount: 1000,
                percentAmount: "5%"
            },
            modifiers: [
                {
                    name: "Sample modifier 2",
                    amount: 500
                },
                {
                    name: "Sample modifier 3",
                    amount: 500
                }
            ],
            taxes: [
                {
                    name: "HST",
                    amount: 1000,
                    percentAmount: "15%"
                },
                {
                    name: "GST",
                    amount: 1000,
                    percentAmount: "10%"
                }
            ],
            productTotal: 2000
        }
    ],
    subtotal: 2000,
    cartDiscount: {
        amount: 200,
        percentAmount: "1%"
    },
    totalDiscount: 500,
    totalTaxes: [
        {
            name: "HST",
            amount: 1000,
            rate: "15%"
        }
    ],
    tips: [
        {
            name: "Tip",
            percentAmount: "5%",
            amount: 500
        }
    ],
    total: 6000,
    shippingAmount: 1000,
    totalRedeemPoint: 10,
    refunds: null,
    signature:
        "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"
};

export const CLSampleData: CashLedgerData = {
    currencySymbol: "$",
    count: 2,
    openingTime: new Date(),
    openingBalance: 4000,
    openedBy: "John Smith",

    closingTime: new Date(),
    closingBalance: 5000,
    closedBy: "John Smith",

    transactions: [
        {
            type: "sale",
            orderId: "46387829",
            time: new Date(),
            taxRates: ["10%", "15%"],
            amount: 150,
            balance: 4150,
            notes: "My comment here"
        },
        {
            type: "sale",
            orderId: "46387829",
            time: new Date(),
            taxRates: ["7%", "2%"],
            amount: 250,
            balance: 4150,
            notes: ""
        },
        {
            type: "withdrawal",
            orderId: null,
            time: new Date(),
            taxRates: ["0%"],
            amount: 500,
            balance: 4000,
            notes: "Alicia Norris - Needed to buy cleaning supplies"
        }
    ],

    added: 700,
    substracted: 1000
};

export const EOSSamplev2: EOSData = {
    count: 110,
    stationName: "Station Name",
    stationId: "001001004",
    dateReportFrom: new Date(),
    openedBy: "John Smith",
    dateReportUntil: new Date(),
    closedBy: "John Smith",

    sessionSummaryBlock: [
        { label: "Gross sales", amount: 12000, bold: true },
        { label: "Total Returns", amount: 0, bold: false },
        { label: "Total Discounts", amount: 0, bold: false },
        { label: "Net Sales", amount: 12000, bold: true },
        { label: "Total taxes", amount: 1500, bold: false },
        { label: "Cash Rounding", amount: 0, bold: false },
        { label: "Tips", amount: 0, bold: false },
        { label: "Total Transaction", amount: 11500, bold: true }
    ],

    paymentsBreakDownBlock: [
        { label: "Cash Payments", amount: 12000, bold: false },
        { label: "FinalPay Terminal", amount: 0, bold: false },
        { label: "FinalPay Tap to Pay", amount: 0, bold: false },
        { label: "Affirm", amount: 12000, bold: false },
        { label: "AfterPay", amount: 1500, bold: false },
        { label: "Total Collected", amount: 11500, bold: true }
    ],

    cashDrawerBlock: [
        { label: "Opening Float", amount: 12000, bold: false },
        { label: "Cash Payments", amount: 0, bold: false },
        { label: "Cash Refunds", amount: 0, bold: false },
        { label: "Cash Added", amount: 12000, bold: false },
        { label: "Cash Removed", amount: 1500, bold: false },
        { label: "Expected Cash Amount", amount: 11500, bold: false },
        { label: "Counted Cash Over/Under", amount: 11500, bold: false },
        { label: "Closing Cash Amount", amount: 11500, bold: true }
    ],

    transactionBlock: {
        transactions: [
            { type: "withdrawal", user: "John Smith", time: new Date(), amount: 500, note: "Removed cash for cleaning supplies" },
            { type: "add", user: "John Smith", time: new Date(), amount: 2500, note: "added some cash to drawer for change" }
        ],
        total: 2000
    },

    taxBreakdown: {
        taxes: [
            { name: "Tax Name 1", rate: "0%", gross: 6500, net: 6500 },
            { name: "Tax Name 2", rate: "7%", gross: 9105, net: 7652 },
            { name: "Tax Name 3", rate: "19%", gross: 50, net: 42 }
        ],
        total: { gross: 15655, net: 14194 }
    },

    refundBlock: {
        tender: [
            { label: "Cash", amount: 2000 },
            { label: "Card", amount: 2000 }
        ],
        total: 4180
    },

    staffBlock: {
        transactions: [
            { name: "John Smith", quantity: 9, gross: 9155 },
            { name: "Sammy Jackson", quantity: 1, gross: 6500 }
        ],
        total: { quantity: 10, gross: 15655 }
    },

    discountBlock: {
        discounts: [
            { type: "Item discount", amount: 25 },
            { type: "Cart discount", amount: 25 }
        ],
        total: 50
    },

    closingNotes: "Cash was over by $3.50 as a customer forgot to take their change."
};

export const variationData = [
    {
        label: "Size",
        value: "size",
        options: [
            { label: "Small", value: "small", checked: false, price: "4599" },
            { label: "Medium", value: "medium", checked: false, price: "4599" },
            { label: "Large", value: "large", checked: false, price: "4599" },
            { label: "XL", value: "xl", checked: false, price: "4999" },
            { label: "XXL", value: "xxl", checked: false, price: "5999" }
        ]
    },
    {
        label: "Color",
        value: "color",
        options: [
            { label: "Blue", value: "blue", checked: false },
            { label: "Red", value: "red", checked: false },
            { label: "Yellow", value: "yellow", checked: false },
            { label: "Purple", value: "purple", checked: false },
            { label: "Black", value: "black", checked: false },
            { label: "Pink", value: "pink", checked: false }
        ]
    }
];

export const customSaleTaxExample = {
    "tax-1": "Tax 1",
    "tax-2": "Tax 2",
    "tax-3": "Tax 3"
};

export const customSaleAddToCartPreviewPrice = `(${formatCurrency(200)})`;

export const simpleCartData: ActiveCart = {
    // id: string;
    // externalId: string;
    // name: string;
    // sku: string;
    // price: number;
    // images: string[];
    // taxTableId: string;
    // quantity: number;
    // note?: string;
    // discount?: Discount;
    // longDescription?: string;
    // shortDescription?: string;
    // barcodeId?: string;
    // stock?: number;
    // allowBackOrder?: boolean;
    customer: {
        _id: v4(),
        companyId: "company123",
        email: "customer@example.com",
        firstName: "John",
        lastName: "Doe",
        billing: null,
        shipping: null
    },
    products: [
        {
            id: "1",
            name: "Facemask",
            externalId: "1",
            internalId: "1",
            sku: "1234",
            attributes: "Red, Blue",
            images: [],
            price: 600,
            quantity: 10,
            taxTableId: "1",
            discount: { value: 0.2, label: "Weekend promo", isPercent: true },
            note: "This is a product note",
            productExternalId: "",
            variantId: "1",
            stock: 10,
            fee: { amount: 0.2, label: "Discount", isPercent: true, applyTaxes: true }
        }

        // {
        //     id: "1",
        //     name: "Sweater",
        //     taxTableId: "2",
        //     externalId: "1",
        //     sku: "1",
        //     price: 4.0,
        //     quantity: 3,
        //     images: [],
        //     productExternalId: "",
        //     variantId: "1",
        //     stock: 10
        // },
        // {
        //     id: "3",
        //     name: "Sneakers",
        //     price: 80.5,
        //     quantity: 1,
        //     taxTableId: "3",
        //     externalId: "1",
        //     sku: "1",
        //     images: [],
        //     productExternalId: "",
        //     variantId: "1",
        //     stock: 10,
        //     fee: { label: "My product fee ", amount: 0.12, isPercent: true, applyTaxes: false },
        //     discount: { value: 0.2, label: "Discount", isPercent: true }
        // }
    ],
    orderNotes: "This is an example of order notes", //TODO ON RENDER
    customFee: [
        { label: "My custom fee ", amount: 2000, isPercent: false, applyTaxes: false },
        { label: "My custom fee 2", amount: 500, isPercent: false, applyTaxes: false }
    ],
    discount: { value: 5000, label: "Cart discount" },
    subtotal: 27900,
    total: 26335,
    tax: 3435,
    cartTotal: 30000,
    amountToBeCharged: 0
};

export const cartPaymentData: PaymentMethod[] = [
    {
        transactionId: "6737553da463e38236ba553b",
        paymentType: "cash",
        amount: 2000,
        timestamp: "2024-11-15T14:05:49.910Z",
        processor: "Cash",
        change: 3500,
        tip: null,
        cashRounding: 0,
        emv: null
    },
    {
        transactionId: "67376f8ca463e38236ba553c",
        paymentType: "card",
        amount: 500,
        timestamp: "2024-11-15T15:58:05.011Z",
        processor: "Card",
        change: 5000,
        tip: null,
        cashRounding: 0,
        emv: '{"Brand":"Scotia","Cardholder Name":"Hans","Country":"Ca","Expiry date":"2019","Issuer":"Debit","Card Number":"**** **** **** 4242"}'
    },
    {
        transactionId: "67z755zda463z38236ba553b",
        paymentType: "cash",
        amount: 2000,
        timestamp: "2024-11-15T14:05:49.910Z",
        processor: "Cash",
        change: 3500,
        tip: null,
        cashRounding: 0,
        emv: null
    }
];

export const previewCustomerNotes: CustomerNote[] = [
    {
        createdAt: "2024-11-15T14:05:49.910Z",
        message: "note1"
    },
    {
        createdAt: "2024-11-18T09:00:00.910Z",
        message: "note2"
    },
    {
        createdAt: "2024-11-18T18:00:00.910Z",
        message: "note3"
    }
];
